import React, { ReactElement } from 'react'

import Activities from '@pages/Checkout/Extras/Ancillary/mocked/Activities'

const MockedAncillaries: Record<number, ReactElement> = {
  807197: <Activities />,
}

export default MockedAncillaries
